import React, { useState, useEffect } from 'react';
import { Alert } from '@smarterservices/smarter-ui';
import { getStore, useExamSessionStore } from '../../../stores/StoreContext';

/**
 * NoFlags Component
 * 
 * Displays informational messages when there are no flags associated with a proctored exam session.
 * Shows different messages based on whether the test taker has started the exam:
 * - Before exam starts: Info alert explaining flags don't start until exam navigation
 * - After exam starts: Success alert confirming no flags exist
 * 
 * @component
 * 
 * @returns {React.ReactElement} Alert component with appropriate message based on exam state
 * 
 * @example
 * <NoFlags />
 */
const NoFlags = () => {
    const [canHaveFlags, setCanHaveFlags] = useState(false);
    const ExamSessionStore = getStore('examSessionStore');

    const journey = useExamSessionStore((state) => state.journey);

    useEffect(() => {
        const hasStep = ExamSessionStore.hasStartedJourneyStep("ExamInProgress");
        if (hasStep) {
            setCanHaveFlags(true);
        }
    }, [journey]);

    if (!canHaveFlags) {
        return (
            <Alert variant="info" transition="none" margin="medium none none none">
                Flags do not start until the test taker navigates to the exam.
            </Alert>
        );
    }

    return (
        <Alert variant="success" transition="none" margin="medium none none none">
            There are no flags associated with this session.
        </Alert>
    );
};

export default NoFlags;
